import Vue from 'vue';
import Vuex from 'vuex';
import posts from '@/posts';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeTag: '',
    posts,
    filteredPosts: posts,
  },
  getters: {
    getActiveTag: state => state.activeTag,
    getPosts: state => state.posts,
    getFilteredPosts: state => state.filteredPosts,
  },

  mutations: {
    filterArticlesByTag(tag) {
      var newPosts = [];

      for (var i = 0; i < this.state.posts.length; i++) {
        var post = this.state.posts[i];
        if(post.tags && post.tags.includes(tag))
          newPosts.push(post);
      }

      this.state.filteredPosts = newPosts;
      this.state.activeTag = tag;
    }
  },
  actions: {
    filterArticlesByTag ({ commit, state }, tag) {
      commit('filterArticlesByTag', tag);
    },
  }
});



// WEBPACK FOOTER //
// ./src/store.js